<template>
  <main>
    <top-section title="Про нас" :breadcrumb="breadcrumb" />
    <section class="about-area3 fix pt-80">
      <div class="container">
        <div class="row support-wrapper">
          <div class="col-sm-12 col-xs-12 col-md-6 about-img__wrapper mb-10">
            <img src="../assets/img/leaders/director.jpg" alt="Director" />
          </div>
          <div class="col-sm-12 col-xs-12 col-md-6">
            <h3>Мої вітання!</h3>
            <p>
              Якщо Ви знаходитесь на цій сторіночці, це означає, що ми з Вами
              обов’язково зустрінемося у стінах закладу! Хочу відзначити, що на
              сьогоднішній день позашкільним навчальним закладам відведено
              важливу роль у реалізації державної політики щодо всебічного
              розвитку обдарованих дітей та учнівської молоді, формування
              творчої особистості вихованців.
            </p>
          </div>
          <div class="col-12">
            <p>
              В Україні функціонують тисячі позашкільних закладів, одним із них
              є Комунальний навчальний заклад «Центр позашкільної освіти»
              Малинівської селищної ради Чугуївського району Харківської
              області. Центр позашкільної освіти створено 20 грудня 2017 року на
              виконання Рішення III сесії Малинівської селищної ради VIII
              cкликання № 26 – ІІІ/VIII. А вже 1 лютого 2018 року заклад відкрив
              свої двері для перших гуртківців.
            </p>
            <p>
              Головною метою діяльності КНЗ «Центр позашкільної освіти» є
              надання дітям та юнацтву позашкільної освіти, спрямованої на
              забезпечення потреб особистості у самореалізації, можливостей для
              творчого розвитку та самовизначення у вільний час, здобуття
              додаткових знань, умінь та навичок за інтересами.
            </p>
          </div>
          <blockquote class="full-width generic-blockquote">
            <footer class="blockquote-footer">
              Кисіль Ольга Вікторівна,
              <cite title="Source Title">директор</cite>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
    <section class="sample-text-area">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3>Умови вступу</h3>
            <p>
              Зарахування учнів до ЦПО може здійснюватися протягом навчального
              року (у міру закінчення комплектування гуртків, секцій, груп) за
              їхнім бажанням і на підставі заяви батьків або осіб, які їх
              замінюють, як на безконкурсній основі, так і за конкурсом, умови
              якого розробляються закладом. Для зарахування вихованців, учнів до
              туристських, спортивних, хореографічних гуртків потрібна
              <b>довідка медичного закладу</b> про те, що в них відсутні
              протипоказання для занять у зазначених гуртках. До закладу
              зараховується вихованці, учні віком від 4 до 18 років.
            </p>
            <p>
              Навчальний рік у гуртках ЦПО починається з
              <b>1 вересня</b> поточного року і закінчується
              <b>31 травня</b> наступного календарного року та поділяється на
              семестри: перший - з <b>1 вересня</b> до <b>31 грудня</b>, другий
              - з <b>1 січня</b> до <b>31 травня</b>. Комплектування гуртків,
              груп та інших творчих об’єднань здійснюється у період з 1 до 15
              вересня.
            </p>
          </div>
        </div>
      </div>
    </section>
    <team />
  </main>
</template>
<script>
import Team from "@/components/Team";
import TopSection from "@/components/TopSection";

export default {
  name: "About",
  components: { TopSection, Team },
  data: () => ({
    breadcrumb: [
      {
        title: "Головна",
        url: "/"
      },
      {
        title: "Про нас",
        url: "/about"
      }
    ]
  })
};
</script>
